import { render } from "./details.vue?vue&type=template&id=e7fd2360&scoped=true&ts=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"

import "./details.vue?vue&type=style&index=0&id=e7fd2360&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/nonbid_zlysz_com_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7fd2360"]])

export default __exports__